import { render } from "./EmailEvent.vue?vue&type=template&id=4b222d06&scoped=true"
import script from "./EmailEvent.vue?vue&type=script&lang=js"
export * from "./EmailEvent.vue?vue&type=script&lang=js"

import "./EmailEvent.vue?vue&type=style&index=0&id=4b222d06&scoped=true&lang=css"

import exportComponent from "/home/ramo/backend/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b222d06"]])

export default __exports__